/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartitionsIncrease
 */
export interface PartitionsIncrease {
    /**
     * 
     * @type {number}
     * @memberof PartitionsIncrease
     */
    totalPartitionsCount: number;
}

export function PartitionsIncreaseFromJSON(json: any): PartitionsIncrease {
    return PartitionsIncreaseFromJSONTyped(json, false);
}

export function PartitionsIncreaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartitionsIncrease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPartitionsCount': json['totalPartitionsCount'],
    };
}

export function PartitionsIncreaseToJSON(value?: PartitionsIncrease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPartitionsCount': value.totalPartitionsCount,
    };
}

